/* ============================================================
 * Scalp Crime : landing pages sombres
 * ------------------------------------------------------------
 * Chargé uniquement quand template.suffix contient 'scalp-crime'.
 *
 * Un seul rôle : la façade vidéo. On affiche la miniature et le
 * bouton play, l'iframe YouTube / Vimeo n'est injectée qu'au clic.
 * Ça évite de charger le player (et ses cookies) au chargement,
 * et ça protège le LCP du hero.
 * ============================================================ */

(function () {
  'use strict';

  function buildEmbedUrl(rawUrl) {
    if (!rawUrl) return null;

    var youtube = rawUrl.match(
      /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/
    );
    if (youtube) {
      return (
        'https://www.youtube-nocookie.com/embed/' +
        youtube[1] +
        '?autoplay=1&rel=0&playsinline=1'
      );
    }

    var vimeo = rawUrl.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vimeo) {
      return 'https://player.vimeo.com/video/' + vimeo[1] + '?autoplay=1';
    }

    return null;
  }

  function activate(facade) {
    if (facade.dataset.scLoaded === 'true') return;

    var embedUrl = buildEmbedUrl(facade.dataset.scVideoUrl);
    if (!embedUrl) return;

    var iframe = document.createElement('iframe');
    iframe.src = embedUrl;
    iframe.title = facade.dataset.scVideoTitle || 'Vidéo';
    iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; picture-in-picture');
    iframe.setAttribute('allowfullscreen', 'true');
    iframe.setAttribute('loading', 'lazy');

    facade.innerHTML = '';
    facade.appendChild(iframe);
    facade.dataset.scLoaded = 'true';
  }

  function init(root) {
    var facades = (root || document).querySelectorAll('[data-sc-video-url]');

    facades.forEach(function (facade) {
      if (facade.dataset.scBound === 'true') return;
      facade.dataset.scBound = 'true';

      facade.addEventListener('click', function () {
        activate(facade);
      });

      facade.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          activate(facade);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Rechargement d'une section depuis l'éditeur de thème
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
